import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { CommentFragments } from '../../graphql/comment.graphql';
import { Comment } from '../../types/comment';
import { commentSlice } from '../../context/CommentContext';
import { useAppDispatch } from '../../ui/pages/store';

const commentSubscription = gql`
  subscription commentNotification($companyId: String!) {
    commentNotification(companyId: $companyId) {
      companyId
      entities {
        ...Comment
      }
      topic
      date
    }
  }
  ${CommentFragments.comment}
`;

export class CommentNotificationResponse extends forNotification<Comment>('commentNotification') {}

export default function CommentNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: commentNotification } = useSubscription<CommentNotificationResponse>(commentSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleCommentNotification = (notification?: CommentNotificationResponse) => {
    if (!notification?.commentNotification) return;
    const commentNotification = notification.commentNotification;

    switch (commentNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(commentSlice.actions.add(commentNotification.entities));
        break;
      case 'DELETE':
        dispatch(commentSlice.actions.delete(commentNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleCommentNotification(commentNotification);
  }, [commentNotification]);

  return <></>;
}
